<template>

  <b-form-group
    :label="label"
    class="bold-label mb-4"
    label-for="id">
    <div v-if="info">{{info}}</div>
    <b-form-tags
      :id="id"
      v-model="selectedTags"
      add-on-change
      no-outer-focus>
      <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
        <b-form-select
          v-bind="inputAttrs"
          v-on="inputHandlers"
          class="mb-2"
          :required="isRequired? !itemsSelected: false"
          :disabled="disabled || availableItemsOptions.length === 0"
          :options="availableItemsOptions">
          <template #first>
            <!-- This is required to prevent bugs with Safari -->
            <option disabled value="">{{ placeholder }}</option>
          </template>
        </b-form-select>
        <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
          <li v-for="tag in tags" :key="tag" class="list-inline-item">
            <b-form-tag
              @remove="removeTag(tag)"
              :title="tag"
              :disabled="disabled">
              {{ tag }}
            </b-form-tag>
          </li>
        </ul>
        <div v-else class="selected-items-empty d-flex align-items-center">
          <span>{{ noSelection }}</span>
        </div>
      </template>
    </b-form-tags>
    <b-form-text>{{helpMessage}}</b-form-text>
  </b-form-group>

</template>

<script>
export default {

  name: 'SelectTagsField',

  props: {
    label: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    noSelection: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default() {
        return []
      }
    },
    itemsInit: {
      type: Array,
      default() {
        return []
      }
    },
    info: {
      type: String,
      default: null
    },
    helpMessage: {
      type: String,
      default: null
    },
    isRequired: {
      type: Boolean,
      default: false
    }
  },

  emits: ['didChangeSelectedItems'],

  data() {
    return {
      selectedTags: []
    }
  },

  watch: {
    'selectedTags': function () {
      let selectedItemsIds = []
      this.selectedTags.map(selectedTag => {
        let item = this.items.find(item => item.tostring === selectedTag)
        if (item) {
          selectedItemsIds.push(item.id)
        }
      })
      this.$emit('didChangeSelectedItems', selectedItemsIds)
    },
    'itemsInit': function() {
      if (this.itemsInit) {
        this.itemsInit.forEach(item =>
          this.selectedTags.push(item.tostring)
        )
      }
    }
  },

  computed: {
    availableItemsOptions() {
      return this.items
        .filter(item =>
          this.selectedTags.indexOf(item.tostring) === -1
        ).map(item => (
          item.tostring
        ))
    },
    itemsSelected() {
      return this.selectedTags.length > 0
    }
  },

  mounted () {
    this.setInitialValues()
  },

  methods: {
    setInitialValues() {
      if (this.itemsInit) {
        this.itemsInit.forEach(item =>
          this.selectedTags.push(item.tostring)
        )
      }
    }
  }

}
</script>

<style scoped>

.b-form-tags {
  background: transparent !important;
  border: none;
  padding: 0;
}

.b-form-tag {
  border: none;
  border-radius: var(--small-border-radius);
  padding: 10px;
  background-color: var(--background-grey);
  color: var(--main-text-color);
  font-size: var(--content-font-size);
}

</style>



// WEBPACK FOOTER //
// src/components/b122/editFields/SelectTagsField.vue